var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "popupMeng" } },
    [
      _vm.isDefault
        ? _c(
            "div",
            { staticClass: "popup", style: _vm.popupStyle },
            [
              _vm.showTitle
                ? _c("p", { staticClass: "popTitle" }, [
                    _vm._v(_vm._s(_vm.title)),
                    _vm.showClose
                      ? _c("span", {
                          staticClass: "close",
                          on: { click: _vm.closePop }
                        })
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default"),
              _vm._v(" "),
              _vm.showPopBtn
                ? _c("div", { staticClass: "popBtnBox" }, [
                    _vm.popBtns.length > 1
                      ? _c("input", {
                          staticClass: "popBtn1",
                          attrs: { type: "button", value: _vm.popBtns[0] },
                          on: { click: _vm.onOk }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.popBtns.length > 1
                      ? _c("input", {
                          staticClass: "popBtn2",
                          attrs: { type: "button", value: _vm.popBtns[1] },
                          on: { click: _vm.onCancle }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.popBtns.length == 1
                      ? _c("input", {
                          staticClass: "popBtn3",
                          attrs: { type: "button", value: _vm.popBtns[0] },
                          on: { click: _vm.onOk }
                        })
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isDefault ? _vm._t("default") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d07db7b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d07db7b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/popup/popup.vue
// module id = 451
// module chunks = 0